import React from 'react';
import { AiOutlinePhone, AiOutlineVideoCamera } from 'react-icons/ai';
import { Row, Col } from 'react-flexbox-grid';
import styles from './style.scss';

function ConferenceData({ event }) {
  const entryPoints = event.getIn(['conferenceData', 'entryPoints']);

  const videoData = entryPoints.find(entry => entry.get('entryPointType') === 'video');
  const phoneData = entryPoints.find(entry => entry.get('entryPointType') === 'phone');
  return (
    <div>
      <hr />
      <Row top="xs" start="xs" style={{ marginTop: 10 }}>
        <Col xs={1}>
          <AiOutlineVideoCamera size={20} />
        </Col>
        <Col xs={11} style={{ textAlign: 'left' }}>
          <a href={videoData.get('uri')} className={styles.zoomButton}>
            Zoom
          </a>
        </Col>
      </Row>
      <Row top="xs" start="xs" style={{ marginTop: 10 }}>
        <Col xs={1}>
          <AiOutlinePhone size={20} />
        </Col>
        <Col xs={11} style={{ textAlign: 'left' }}>
          {phoneData.get('label')}
        </Col>
      </Row>
    </div>
  );
}

export default ConferenceData;



// WEBPACK FOOTER //
// ./src/widget/event_components/conference_data.js